/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Button, Label, Input, Tooltip } from "reactstrap";
import * as Constdata from "../../Constants/ApiConstants";
import * as message from "../../Constants/MessageConstant";
import SerraLoader from "../CommonComponent/Loader";

class VMRecommendationPreferences extends Component {
  constructor(props) {
    super(props);
    this.keyPress = this.keyPress.bind(this);
    this.handleRecommendationPreferenceRequest =
      this.handleRecommendationPreferenceRequest.bind(this);
    this.savePref = this.savePref.bind(this);
    this.toggleTooltips = this.toggleTooltips.bind(this);
    this.state = {
      errorPopup: false,
      modalLoader: false,
      isErrorHeader: true,
      errormessage: "",
      isRedirect: false,
      recommendationPreference: false,
      tooltipOpen: false,
      enhancedCostRatio: 0,
      economicalPerfRatio: 0,
      tooltipOpenEnhancedCostRatio: false,
      tooltipOpenEconomicalPerfRatio: false,
      isSameTempStorage: false,
    };
  }

  componentDidMount() {
    this.handleRecommendationPreferenceRequest();
  }

  handleRecommendationPreferenceRequest = () => {
    this.setState({ modalLoader: true });

    let payload = {
      providerName: this.props.providerName,
      orgId: this.props.orgId,
    };

    fetch(`${Constdata.SET_VM_RECOMMENDATION_PREFERENCES}`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.success === true) {
          this.setState({
            recommendationPreference: responseJson.data.isSameVMGeneration,
            economicalPerfRatio: responseJson.data.economicalPerfRatio,
            enhancedCostRatio:
              responseJson.data.enhancedCostRatio > 100
                ? 1100
                : responseJson.data.enhancedCostRatio,
            modalLoader: false,
            isSameTempStorage: responseJson.data.isSameTempStorage,
          });
        } else if (responseJson.status === 403 || responseJson.status === 401) {
          this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.SessionExpiredText,
            isErrorHeader: false,
          });
        } else {
          this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.ServerError,
            isErrorHeader: false,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          modalLoader: false,
          errorPopup: true,
          errormessage: message.CacheErrorText,
          isErrorHeader: false,
        });
      });
  };
  keyPress(e) {
    if (e.keyCode >= 65 && e.keyCode <= 90) {
      e.preventDefault();
    }
  }

  async savePref() {
    this.setState({ modalLoader: true });

    let payload = {
      isSameVMGeneration: this.state.recommendationPreference,
      providerName: this.props.providerName,
      economicalPerfRatio: this.state.economicalPerfRatio,
      enhancedCostRatio:
        this.state.enhancedCostRatio > 100
          ? 1000000000
          : this.state.enhancedCostRatio,
      orgId: this.props.orgId,
      isSameTempStorage: this.state.isSameTempStorage,
    };

    fetch(`${Constdata.SET_VM_RECOMMENDATION_PREFERENCES}`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({ modalLoader: false });
        this.props.handleRecommendationPreference(responseJson);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleRecommendationPreference = () => {
    this.setState({
      recommendationPreference: !this.state.recommendationPreference,
    });
  };

  toggleTooltips = () =>
    this.setState({ tooltipOpen: !this.state.tooltipOpen });

  toggleTooltipsEnhancedCostRatio = () =>
    this.setState({
      tooltipOpenEnhancedCostRatio: !this.state.tooltipOpenEnhancedCostRatio,
    });

  toggleTooltipsEconomicalPerfRatio = () =>
    this.setState({
      tooltipOpenEconomicalPerfRatio:
        !this.state.tooltipOpenEconomicalPerfRatio,
    });

  handleToggle = () => {
    this.setState((prevState) => ({
      isSameTempStorage: !prevState.isSameTempStorage,
    }));
  };

  render() {
    return (
      <div>
        <div
          className="container-verf container-verf-margin pageBgWhite"
          style={{ borderRadius: "10px" }}
          role="main"
        >
          <div className="frm-container" style={{ textAlign: "center" }}>
            <div className="recommendationPreferences">
              <Input
                class="form-check-input"
                onClick={(e) => this.handleRecommendationPreference(e)}
                checked={this.state.recommendationPreference}
                type="checkbox"
                id="rp"
                name="recommendationPreferences"
                value={this.state.recommendationPreference}
              />
              <Label for="rp" style={{ paddingLeft: "5px" }}>
                {this.props.providerName === "AZURE"
                  ? "Recommended VM Size needs to support the same VM generation as the Analyzed VM Size"
                  : "Recommended Instance Architecture should be the same as the Analyzed Instance Architecture."}
                <i
                  id="Tooltip"
                  style={{ marginLeft: "10px" }}
                  className="fa fa-info-circle"
                  aria-hidden="true"
                />
                <Tooltip
                  placement="bottom"
                  isOpen={this.state.tooltipOpen}
                  target={"Tooltip"}
                  toggle={this.toggleTooltips}
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    border: "1px solid black",
                    textAlign: "left",
                  }}
                >
                  <div style={{ lineHeight: 1.1 }}>
                    {this.props.providerName === "AZURE"
                      ? message.RecommendationPreferenceMsg
                      : message.RecommendationPreferenceMsgAWS}
                  </div>
                </Tooltip>
              </Label>
            </div>

            {this.props.providerName === "AZURE" && (
              <div
                className="recommendationPreferencesAzure"
                style={{
                  alignItems: "baseline",
                  display: "flex",
                  gap: "5px",
                  marginLeft: "150px",
                }}
              >
                <Input
                  id="control-outline"
                  type="checkbox"
                  name="outline"
                  checked={this.state.isSameTempStorage}
                  onClick={this.handleToggle}
                />
                <Label>
                  Ensure Temp Storage is at least as large as with Current VM
                </Label>
              </div>
            )}

            <div
              style={{
                // marginLeft: "134px",
                marginTop: "15px",
                display: "flex",
              }}
              className="preferenceRatio"
            >
              {/* Economical performance ratio    */}

              <div
                style={{
                  width: "300px",
                  margin: "0 auto",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "17px",
                  }}
                >
                  <div for="economicalPerfRatio">
                    Economical performance ratio
                  </div>
                  <div>
                    <i
                      id="economicalPerfRatio1"
                      style={{ marginLeft: "7px", fontSize: "18px" }}
                      className="fa fa-info-circle"
                    ></i>
                    <Tooltip
                      placement="bottom"
                      isOpen={this.state.tooltipOpenEconomicalPerfRatio}
                      target={"economicalPerfRatio1"}
                      toggle={this.toggleTooltipsEconomicalPerfRatio}
                      style={{
                        backgroundColor: "white",
                        color: "black",
                        border: "1px solid black",
                        textAlign: "left",
                        minWidth:
                          window.innerWidth >= 1702
                            ? "55%"
                            : window.innerWidth >= 1561
                            ? "60%"
                            : window.innerWidth >= 1379
                            ? "68%"
                            : "75%",
                      }}
                    >
                      <div style={{ lineHeight: 1.1 }}>
                        ratio of one or less that determines how much lower the
                        economical performance can be
                      </div>
                    </Tooltip>
                  </div>
                </div>
                <div style={{ position: "relative", marginBottom: "20px" }}>
                  {/* Slider */}
                  <input
                    type="range"
                    step="0.01"
                    min="0"
                    max="1"
                    name="economicalPerfRatio"
                    id="economicalPerfRatio"
                    value={this.state.economicalPerfRatio}
                    onChange={(e) => {
                      let value = parseFloat(e.target.value);
                      this.setState({ economicalPerfRatio: value });
                    }}
                    style={{ width: "100%" }}
                  />
                  {/* Active Range Value */}
                  <div
                    style={{
                      position: "absolute",
                      left: `${
                        ((this.state.economicalPerfRatio - 0.01) / (1 - 0.01)) *
                        100
                      }%`,
                      top: "-22px",
                      transform: "translateX(-50%)",
                      backgroundColor: "#007bff",
                      color: "#fff",
                      padding: "2px 5px",
                      borderRadius: "5px",
                      fontSize: "12px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {this.state.economicalPerfRatio}
                  </div>
                </div>
                {/* Min and Max Values */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "12px",
                    marginTop: "-25px",
                  }}
                >
                  <span>0</span>
                  <span>1.00</span>
                </div>
              </div>

              {/* Enhanced cost ratio */}
              <div
                style={{
                  width: "300px",
                  margin: "0 auto",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "17px",
                  }}
                >
                  <div for="enhancedCostRatio">Enhanced cost ratio</div>
                  <div>
                    <i
                      id="enhancedCostRatio1"
                      style={{ marginLeft: "7px", fontSize: "18px" }}
                      className="fa fa-info-circle"
                    ></i>
                    <Tooltip
                      placement="bottom"
                      isOpen={this.state.tooltipOpenEnhancedCostRatio}
                      target={"enhancedCostRatio1"}
                      toggle={this.toggleTooltipsEnhancedCostRatio}
                      style={{
                        backgroundColor: "white",
                        color: "black",
                        border: "1px solid black",
                        textAlign: "left",
                        minWidth:
                          window.innerWidth >= 1702
                            ? "55%"
                            : window.innerWidth >= 1561
                            ? "60%"
                            : window.innerWidth >= 1379
                            ? "68%"
                            : "75%",
                      }}
                    >
                      <div style={{ lineHeight: 1.1 }}>
                        ratio of one or more that determines how much higher the
                        enhanced cost can be
                      </div>
                    </Tooltip>
                  </div>
                </div>
                <div style={{ position: "relative", marginBottom: "20px" }}>
                  {/* Slider */}
                  <input
                    type="range"
                    step="1"
                    min="1"
                    max="110"
                    name="enhancedCostRatio"
                    id="enhancedCostRatio"
                    value={this.state.enhancedCostRatio}
                    onChange={(e) => {
                      let value = parseFloat(e.target.value);
                      this.setState({ enhancedCostRatio: value });
                    }}
                    style={{ width: "100%" }}
                  />
                  {/* Active Range Value */}
                  <div
                    style={{
                      position: "absolute",
                      left: `${
                        ((this.state.enhancedCostRatio - 1) / (110 - 1)) * 100
                      }%`,
                      top: "-22px",
                      transform: "translateX(-50%)",
                      backgroundColor: "#007bff",
                      color: "#fff",
                      padding: "2px 5px",
                      borderRadius: "5px",
                      fontSize: "12px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {this.state.enhancedCostRatio > 100
                      ? "∞"
                      : this.state.enhancedCostRatio}
                  </div>
                </div>
                {/* Min and Max Values */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "12px",
                    marginTop: "-25px",
                  }}
                >
                  <span>1</span>
                  <span
                    style={{
                      position: "absolute",
                      left: `${(895 / 110) * 100}%`,
                    }}
                  >
                    100
                  </span>
                  <span style={{ fontSize: "18px", marginTop: "-5px" }}>∞</span>
                </div>
              </div>
            </div>

            <div
              class="btn-toolbar pageBgWhite"
              role="toolbar"
              aria-label="Toolbar with button groups"
              style={{
                display: "flex",
                padding: "20px",
                marginTop: "20px",
                justifyContent: "flex-end",
                borderRadius: "0px 0px 10px 10px",
              }}
            >
              <div
                class="mr-2"
                role="group"
                aria-label="Third group"
                className="modalBtn"
                id="knowMoreFooter"
              >
                <Button id="confirmbtn_list" onClick={this.savePref}>
                  Save
                </Button>
              </div>
              <div role="group" aria-label="First group">
                <Button
                  className="btn-cancel btn btn-light"
                  onClick={this.props.toggle}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </div>
        {this.state.modalLoader === true ? <SerraLoader></SerraLoader> : ""}
      </div>
    );
  }
}
export default withRouter(VMRecommendationPreferences);
